import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DESAFIO_PERSONAL } from '@env';
import { Storage } from '@ionic/storage';

@Injectable()
export class DesafioPersonalProvider {

  constructor(public http: HttpClient,  private storage: Storage) { }

  setEstadisticasRonda(preguntas: any ): Promise<any> {
    return this.storage.set('estadisticasRonda', preguntas);
  }

  getEstadisticasRonda(): Promise<any> {
    return this.storage.get('estadisticasRonda').then((estadisitcas) => {
      if( !estadisitcas && !this.validaEstadisticasRonda(estadisitcas)) {
        return null;
      }
      return estadisitcas;
    });
  }

  private validaEstadisticasRonda(estadistica) {
    return estadistica && estadistica.estadisticas &&  estadistica.jugador;
  }

  setRondaActual(ronda: any ): Promise<any> {
    return this.storage.set('rondaPersonal', ronda);
  }

  getRondaActual(): Promise<any> {
    return this.storage.get('rondaPersonal').then((ronda) => {
      if( !ronda && !this.validaRonda(ronda)) {
        return null;
      }

      return ronda;
    });
  }


  async muestraModalBots(): Promise<any> {
    return this.storage.get('modalBot')
  }

  ocultaModalBots(): Promise<any> {
    return this.storage.set('modalBot', true);
  }

  private validaRonda(ronda) {
    return ronda && ronda.jugador && ronda.equipo && ronda.juego;
  }

  clearRondaActual(): Promise<any> {
    return this.setEstadisticasRonda(null)
    .then( _ => {
      return this.setRondaActual(null);
    });
  }

  puedeRetar(area: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.PUEDE_RETAR}${area}` ).toPromise();
  }

  buscar(area: string, jugador: string, query: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.BUSCAR_JUGADOR}${area}/${jugador}?qry=${query}` ).toPromise();
  }

  sugerencias(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.SUGERENCIAS}${area}/${jugador}` ).toPromise();
  }

  aleatorio(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.ALEATORIO}${area}/${jugador}` ).toPromise();
  }

  directo(area: string, jugador: string, retador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.DIRECTO}${area}/${jugador}/${retador}` ).toPromise();
  }

  actualiza(reto: string, infoRonda: any, area: string): Promise<any> {
    return this.http.post( `${DESAFIO_PERSONAL.ACTUALIZA}${reto}/${area}`, infoRonda ).toPromise();
  }

  enCurso(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.EN_CURSO}${area}/${jugador}` ).toPromise();
  }

  enCursoMiTurno(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.EN_CURSO}mi-turno/${area}/${jugador}` ).toPromise();
  }

  enCursoSuTurno(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.EN_CURSO}su-turno/${area}/${jugador}` ).toPromise();
  }

  caducados(area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.CADUCADOS}${area}/${jugador}` ).toPromise();
  }

  actualizaCaducados(area: string, jugador: string): Promise<any> {
    return this.http.post( `${DESAFIO_PERSONAL.CADUCADOS}${area}/${jugador}`, {} ).toPromise();
  }

  miTurno(desafio: string, openente: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.MI_TURNO}${desafio}/${openente}` ).toPromise();
  }

  primerDesafio( area: string, jugador: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.PRIMER_DESAFIO}${area}/${jugador}` ).toPromise();
  }

  score(jugador: string, area: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.SCORE}${jugador}/${area}` ).toPromise();
  }

  retoBot(area: string): Promise<any> {
    return this.http.get( `${DESAFIO_PERSONAL.RETO_BOT}${area}` ).toPromise();
  }

  saveStatsBot(reto: any): Promise<any> {
    return this.http.post( `${DESAFIO_PERSONAL.SAVE_STATS_BOT}`, reto ).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/providers/desafio-personal/desafio-personal.ts